<div class="dialog-header">
  <mat-icon class="dialog-back" (click)="$event.stopPropagation(); tryClose('back')">chevron_left</mat-icon>
  <span class="dialog-title">{{ isEdit ? 'Bildblock bearbeiten' : 'Bildblock hinzufügen' }}</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose(null)">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Titel (optional)</label>
  <div class="field-with-counter">
    <input class="field-input"
           [class.field-error]="form.controls['title'].hasError('maxlength')"
           [formControl]="$any(form.controls['title'])"
           [maxlength]="maxInput">
    <span class="char-counter" [class.char-counter--over]="form.controls['title'].hasError('maxlength')">
      {{ (form.controls['title'].value?.length || 0) }} / {{ maxInput }}
    </span>
  </div>
  @if (form.controls['title'].hasError('maxlength')) {
    <p class="validation-error">Titel darf maximal {{ maxInput }} Zeichen lang sein.</p>
  }

  <label class="field-label">Beschreibungstext (optional)</label>
  <div class="field-with-counter">
    <textarea class="field-input"
              [class.field-error]="form.controls['body_text'].hasError('maxlength')"
              [formControl]="$any(form.controls['body_text'])"
              rows="4"
              [maxlength]="maxInput"></textarea>
    <span class="char-counter" [class.char-counter--over]="form.controls['body_text'].hasError('maxlength')">
      {{ (form.controls['body_text'].value?.length || 0) }} / {{ maxInput }}
    </span>
  </div>
  @if (form.controls['body_text'].hasError('maxlength')) {
    <p class="validation-error">Beschreibungstext darf maximal {{ maxInput }} Zeichen lang sein.</p>
  }

  <label class="field-label">Bilddatei{{ isEdit ? '' : '*' }}</label>
  <div class="file-upload-row" (click)="fileInput.click()">
    <mat-icon class="upload-icon">cloud_upload</mat-icon>
    <span class="upload-label">Datei Upload{{ isEdit ? '' : '*' }}</span>
    <span class="upload-hint">(Max. 3 MB, Formate: jpg, png)</span>
    <input #fileInput type="file" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)">
  </div>
  @if (fileError) {
    <p class="file-error">{{ fileError }}</p>
  }

  @if (imagePreviewUrl) {
    <div class="image-preview">
      <img [src]="imagePreviewUrl" alt="Vorschau" style="max-width: 100%; border-radius: 8px;">
    </div>
  }
</div>
<div class="dialog-footer">
  <div class="dialog-footer-content">
    @if (saveBlockedReason) {
      <p class="save-blocked-reason" role="alert">{{ saveBlockedReason }}</p>
    }
    <button class="dialog-save-btn"
            (click)="save()"
            [disabled]="!isValid"
            [attr.title]="saveBlockedReason">
      Speichern
    </button>
  </div>
</div>
